import { useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddELearningCourses from "./AddELearningCourses";

const ELearningCourses = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);

    return (
        <>
            <AddELearningCourses
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false);
                    setData(null);
                }}
                data={data}
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>E-Learning Courses</div>
                                    <CustomButton
                                        isLoading={false}
                                        label={data ? 'Edit' : 'Add'}
                                        onClick={() => {
                                            setShowAddModal(true);
                                        }}
                                        style={{ width: 100 }}
                                    />
                                </div>
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default ELearningCourses;